module.exports = __webpack_public_path__ + "static/media/img-placeholder-wide.f2b0e480.svg";